
import JoinRoom from './joinRoom';
import ComingSoon from './comingSoon';
import React, {useRef, useEffect} from 'react';
import { selectPeers, 
    selectIsConnectedToRoom,
    useHMSActions,
    useHMSStore } from "@100mslive/react-sdk";

let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

const NDAER_URL_NGROK = "https://86a2-2600-1700-6450-4000-e90b-7ad6-121e-da45.ngrok.io/documents"
const NDAER_URL=  "http://localhost:3001/documents"
const Guest_vid ="https://townhall.app.100ms.live/meeting/ymm-jmt-lsr"
const OM_API ="https://open-mic-api.onrender.com"
const OM_App_URL ="https://open-mic-app.netlify.app"

//  let el2
function VidConf(props) {
const peers = useHMSStore(selectPeers);
const isConnected = useHMSStore(selectIsConnectedToRoom);
const hmsActions = useHMSActions();

  function routeHome(){
    window.location.href = `/`
  }
  console.log("process.env.NDAER_URL",process.env.NDAER_URL)
  // }, []);
  
    return (
        // <div className="test_container center">
        <>
        {/* <ComingSoon></ComingSoon> */}
        <iframe src={OM_App_URL+'/room'} allow="camera *;microphone *" width="320px" height="517px" id="test_iframe"  title='OpenMic video conferencing'>
          {/* <iframe src={`${Guest_vid}`} width="100%" height="517px" id="test_iframe" allow="camera;microphone" title='video conferencing' X-Frame-Options='SAMEORIGIN'> */}
         </iframe> 
{/* {isConnected && (
      <button
      id="leave-btn"
      className="btn-danger"
      onClick={() => hmsActions.leave()}
      >
            Leave Room
            </button>
        )}
    
        {isConnected ?  <VidConf /> : <JoinRoom />} 
        
     </div> */}

        </>
  );
}
export default VidConf; 